import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// 防止路由菜单重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const _import = require("./import-" + process.env.NODE_ENV);
const globalRoutes = [
  {
    path: "/resetpwd",
    component: _import("resetpwd/resetpwd"),
    name: "resetpwd",
    meta: { title: "忘记密码", mod: "resetpwd" },
  },
  {
    path: "/register",
    component: _import("register/register"),
    name: "register",
    meta: { title: "注册" },
  },
  {
    path: "/404",
    component: _import("common/404"),
    name: "404",
    meta: { title: "404未找到" },
  },
];
const mainRoutes = [
  {
    path: "/",
    name: "layout",
    component: _import("layout/Index"),
    redirect: { name: "home" },
    meta: { title: "布局" },
    children: [
      {
        path: "/home",
        name: "home",
        component: _import("home/Home"),
        meta: { title: "首页" },
      },
      {
        path: "/container",
        name: "container",
        component: _import("container/Index"),
        meta: { title: "容器" },
        children: [
          {
            path: "/about",
            name: "about",
            component: _import("about/Index"),
            redirect: { name: "introduction" },
            meta: { title: "公司概况" },
            children: [
              {
                path: "/introduction",
                name: "introduction",
                component: _import("about/Introduction"),
                meta: { title: "公司概况" },
              },
            ],
          },
          {
            path: "/news",
            name: "news",
            component: _import("news/Index"),
            redirect: { name: "broadcast" },
            meta: { title: "新闻公告" },
            children: [
              {
                path: "/centerNews",
                name: "centerNews",
                component: _import("news/CenterNews"),
                meta: { title: "中心新闻" },
                children: [
                  {
                    path: "/newsDetails",
                    name: "newsDetails",
                    component: _import("news/NewsDetails"),
                    meta: { title: "新闻详情" },
                  },
                ],
              },

              {
                path: "/broadcast",
                name: "broadcast",
                component: _import("news/Broadcast"),
                meta: { title: "通知公告" },
                children: [
                  {
                    path: "/broadDetails",
                    name: "broadDetails",
                    component: _import("news/BroadcastDetails"),
                    meta: { title: "公告详情" },
                  },
                ],
              },
            ],
          },
          {
            path: "/honor",
            name: "honor",
            component: _import("honor/Index"),
            redirect: { name: "credential" },
            meta: { title: "资质荣誉" },
            children: [
              {
                path: "/credential",
                name: "credential",
                component: _import("honor/Credential"),
                meta: { title: "技术资质" },
              },
              {
                path: "/cpyhonor",
                name: "cpyhonor",
                component: _import("honor/Cpyhonor"),
                meta: { title: "公司荣誉" },
              },
              {
                path: "/honorDetails",
                name: "honorDetails",
                component: _import("honor/details"),
                meta: { title: "荣誉详情" },
              },
            ],
          },
          {
            path: "/device",
            name: "device",
            component: _import("device/Index"),
            redirect: { name: "allequpt" },
            meta: { title: "仪器设备" },
            children: [
              {
                path: "/allequpt",
                name: "allequpt",
                component: _import("device/Allequpt"),
                meta: { title: "全部设备" },
              },
              {
                path: "/centralequpt",
                name: "centralequpt",
                component: _import("device/Centralequpt"),
                meta: { title: "公司设备" },
              },
              {
                path: "/shareequpt",
                name: "shareequpt",
                component: _import("device/Shareequpt"),
                meta: { title: "共享设备" },
              },
              {
                path: "/hosequpt",
                name: "hosequpt",
                component: _import("device/Hosequpt"),
                meta: { title: "院内设备" },
              },
              {
                path: "/outresources",
                name: "outresources",
                component: _import("device/Outresources"),
                meta: { title: "外部资源" },
              },
              {
                path: "/devicedetail",
                name: "devicedetail",
                component: _import("device/Devicedetail"),
                meta: { title: "设备详情" },
              },
              {
                path: "/hosequptDetail",
                name: "hosequptDetail",
                component: _import("device/HosequptDetail"),
                meta: { title: "设备详情" },
              }
            ],
          },
          {
            path: "/service",
            name: "service",
            component: _import("service/Index"),
            redirect: { name: "demand" },
            meta: { title: "技术服务" },
            children: [
              {
                path: "/demand",
                name: "demand",
                component: _import("service/Demand"),
                meta: { title: "技术需求" },
              },
              {
                path: "/cocreation",
                name: "cocreation",
                component: _import("service/Cocreation"),
                meta: { title: "协创资源" },
              },
              {
                path: "/standard",
                name: "standard",
                component: _import("service/Standard"),
                meta: { title: "标准服务" },
              },
              {
                path: "/serviceDetail",
                name: "serviceDetail",
                component: _import("service/details"),
                meta: { title: "详情" },
              },
              {
                path: "/serviceAdd",
                name: "serviceAdd",
                component: _import("service/add"),
                meta: { title: "我要投稿" },
              },
            ],
          },
          {
            path: "/personal",
            name: "personal",
            component: _import("personal/Index"),
            redirect: { name: "myorder" },
            meta: { title: "个人中心" },
            children: [
              {
                path: "/myorder",
                name: "myorder",
                component: _import("personal/Myorder"),
                meta: { title: "我的订单" },
              },
              {
                path: "/orderDetails",
                name: "orderDetails",
                component: _import("personal/Orderdetails"),
                meta: { title: "我的订单-订单详情" },
              },
              {
                path: "/contribute",
                name: "contribute",
                component: _import("personal/Contribute"),
                meta: { title: "我的投稿" },
              },
              {
                path: "/serviceUserAdd",
                name: "serviceUserAdd",
                component: _import("service/add"),
                meta: { title: "我的投稿-投稿详情" },
              },
              {
                path: "/basicinfo",
                name: "basicinfo",
                component: _import("personal/Basicinfo"),
                meta: { title: "基本信息" },
              },
              {
                path: "/updatepwd",
                name: "updatepwd",
                component: _import("personal/Updatepwd"),
                meta: { title: "修改密码" },
              },
            ],
          },

          {
            path: "/guide",
            name: "guide",
            component: _import("guide/Index"),
            redirect: { name: "reservation" },
            meta: { title: "用户指南" },
            children: [
              {
                path: "/reservation",
                name: "reservation",
                component: _import("guide/Reservation"),
                meta: { title: "仪器预约流程" },
              },
              {
                path: "/sample",
                name: "sample",
                component: _import("guide/Sample"),
                meta: { title: "样品类型" },
              },
            ],
          },
        ],
      },
      {
        path: "/contactUs",
        name: "contactUs",
        component: _import("contactus/Index"),
        meta: { title: "联系我们" },
      },
      {
        path: "/userguide",
        name: "userguide",
        component: _import("guide/Userguide"),
        meta: { title: "用户指南" },
      },
      {
        path: "/order",
        name: "order",
        component: _import("order/Index"),
        meta: { title: "下单" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes: [...globalRoutes, ...mainRoutes],
  scrollBehavior: () => ({ y: 0 }), //滚动到顶端
});
// const router = new VueRouter({
//   mode: 'hash',
//   scrollBehavior: () => ({ y: 0 }),
//   routes: globalRoutes.concat(mainRoutes),
// })

export default router;
